import { skipToken, useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

/** How often to refresh the viewer URL (25 minutes, before the 30-min presigned URL expires) */
const REFRESH_INTERVAL_MS = 25 * 60 * 1000;

interface UseDocumentViewerUrlOptions {
  documentId: string | undefined;
  /** Whether to enable auto-refresh of the viewer URL. Defaults to true. */
  autoRefresh?: boolean;
}

/**
 * Hook to fetch and auto-refresh the Office Online viewer URL for a document.
 * Uses TanStack Query for caching, race condition handling, and auto-refetch.
 */
export function useDocumentViewerUrl({
  documentId,
  autoRefresh = true,
}: UseDocumentViewerUrlOptions) {
  return useQuery({
    ...orpc.core.documents.getViewerUrl.queryOptions({
      input: documentId ? { documentId } : skipToken,
    }),
    enabled: Boolean(documentId),
    refetchInterval: autoRefresh ? REFRESH_INTERVAL_MS : false,
    refetchOnWindowFocus: autoRefresh,
    staleTime: REFRESH_INTERVAL_MS,
  });
}
